<template>
  <aside
    class="store-sidebar"
    :class="{ 'store-sidebar--collapsed': !filtersVisible }"
  >
    <div class="store-sidebar__inner">
      <SearchForm />

      <form class="form--styled">
        <FilterGroup
          v-for="group in activeGroups"
          :key="group.name"
          :group="group"
        />
      </form>
    </div>
  </aside>
</template>

<script>
import { mapState } from 'vuex'
import FilterGroup from './FilterGroup'
import SearchForm from './SearchForm'

export default {
  name: 'Sidebar',

  components: {
    FilterGroup,
    SearchForm
  },

  computed: {
    ...mapState([
      'filters',
      'currentFilters',
      'filtersVisible'
    ]),

    activeGroups () {
      const currentFilters = this.currentFilters

      return this.filters.filter((group) => {
        if (!group.has_filters) {
          return false
        }

        if (group.hasOwnProperty('depends_on')) {
          return group.depends_on.some(id => currentFilters.map(filter => filter.id).includes(id))
        }

        return true
      })
    }
  }
}
</script>
